require.register("app/product/show/StatTab", function(exports, require, module){
  $0
  
});

